// 창작 방식별로 고를 수 있는 변형 정도 (복제·자동 생성은 1~2단계 선택, 기출·사설·순수 창작은 원본)
const CREATION_TYPES_BY_PROBLEM_TYPE: Record<string, string[]> = {
  copy: ['first', 'second'],
  problem_generator: ['first', 'second'],
};

export const filterCreationTypesByProblemType = <T extends { key: string }>(
  enumPairs: readonly T[],
  problemType?: string | null,
): readonly T[] => {
  const allowed = CREATION_TYPES_BY_PROBLEM_TYPE[problemType ?? ''] ?? ['original'];
  return enumPairs.filter(({ key }) => allowed.includes(key));
};
